"use client"

import { DatesProvider } from "@mantine/dates"
import { usePathname } from "next/navigation"
import { useEffect } from "react"
import { useTranslation } from "react-i18next"
import { useAuth } from "@/hooks"
import { dayjs } from "@/utils"
import { Redirect } from "./utils"

export function InitProvider({ children }: { children: React.ReactNode }) {
  const auth = useAuth()
  const pathname = usePathname()
  const { i18n } = useTranslation()

  // Set locale for i18n and dayjs
  const locale = auth?.user?.locale || "en"
  useEffect(() => {
    if (locale) {
      i18n.changeLanguage(locale)
      dayjs.locale(locale == "en" ? "en-gb" : locale)
    }
  }, [locale])

  if (auth.user) {
    if (!auth.company) {
      if (pathname !== "/issue/guest") return <Redirect to="/issue/guest" />
    } else if (auth.company.is_onboarding && pathname !== "/company/onboard") {
      return <Redirect to="/company/onboard" />
    }
  }

  return <DatesProvider settings={{ consistentWeeks: true, locale }}>{children}</DatesProvider>
}
